import Carousel, { CarouselItem } from "components/Common/Carousel/Carousel.tsx";
import React, { useEffect, useMemo } from "react";
import useOBLandingStore from "store/useOBLandingStore.ts";
import "./styles.scss";
import { MediaType, MediaTypeEnum } from "components/Common/Card/Base/types.ts";
import JobTemplateIcon from "assets/images/jobs-template/JobTemplateIcon.png";
import { useTranslation } from "react-i18next";

const EmptyStateCarousel = (
) => {
  const { getArticles, articles, handleViewArticle } = useOBLandingStore();

  const { t } = useTranslation();

  useEffect(() => {
    getArticles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formattedArticles: CarouselItem[] = useMemo(() => articles.map(article => ({
    id: article.key,
    title: {
      text: article.title
    },
    description: {
      text: "" // need to ask Dima
    },
    headerMedia: {
      src: article?.image ? article.image : JobTemplateIcon,
      type: MediaTypeEnum[article.type as MediaType]
    },
    author: article.author,
    viewsAmount: article.views_amount,
    openIn: article.open_in,
    url: article.url,
    embedCode: article.embed_code
  })), [articles]);

  return (
    <div className="pb-16">
      <Carousel
        showArrows
        items={formattedArticles}
        title={t("emptyState.needingMoreHelp")}
        withProgress
        shouldItemsOverflow
        onCardClick={item => handleViewArticle(item.id)}
      />
    </div>
  );
};

export default EmptyStateCarousel;
